export default function (context) {
  // console.log(context);
  if (window.location.hostname.includes(context.env.governmentBaseUrl)){
    context.app.head.title = 'Government Phone Streaming';
    context.app.head.link[0] = { rel: 'icon', type: 'image/x-icon', href: '/government/logo/icon.png' };
  }else{
    context.app.head.title = 'PhoneLive';
  }
  document.title = context.app.head.title;
  return context;
}
